import { createAsyncThunk } from "@reduxjs/toolkit";
import { promotionApi } from "api/promotion";

export const getListPromotion = createAsyncThunk(
  "promotion/getListPromotion",
  async (_, { rejectWithValue }) => {
    try {
      const response = await promotionApi.getPromotionList();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
